export const profile = {
  name: 'Gabriel Huayamabe',
  title: {
    en: 'Systems Engineer | Senior Full-Stack Developer',
    es: 'Ingeniero en Sistemas | Desarrollador Full-Stack Senior'
  },
  role: {
    en: 'Senior Full-Stack Developer',
    es: 'Desarrollador Full-Stack Senior'
  },
  location: 'Guayaquil, Ecuador',
  phone: '0994405445',
  email: 'ghuayamabe89@gmail.com',
  linkedin: 'https://www.linkedin.com/in/gabriel-huayamabe-aba907120/',
  years: '11+',
  summary: {
    en: 'Systems Engineer and Full-Stack Developer with 11+ years of robust experience across the full software development lifecycle, from Frontend and Backend development to technical leadership, system architecture and high-scale e-commerce platforms across Latin America.',
    es: 'Ingeniero en Sistemas y desarrollador Full-Stack con más de 11 años de experiencia en todo el ciclo de desarrollo de software, desde Frontend y Backend hasta liderazgo técnico, arquitectura de sistemas y plataformas e-commerce de alto tráfico en Latinoamérica.'
  },
  availability: {
    en: 'Available for Remote Work',
    es: 'Disponible para trabajo remoto'
  }
}
